import React , {useEffect}from 'react';
import {Link} from 'react-router-dom';
import styled from '@emotion/styled';
// import { AndroidApp } from '../DownLoadMobileApp';
import { useTranslation } from 'react-i18next';
import MobileAppPhoto from '../../assets/images/mobile-app-photo-home.jpg';
import { TextContainer, DownLoadText , GooglePlay } from '../DownLoadMobileApp';
import {ReactComponent as GooglePlaySVG} from '../../assets/svgs/google-play-svg.svg'
import Aos from "aos";
import 'aos/dist/aos.css';

const Container = styled.div`
    display:flex;
    margin-bottom: 100px;

    @media (max-width: 768px) {
      flex-direction:column;
      align-items:center;
      text-align:center;
      justify-content:center;
      margin-bottom: 50px;
    }

`;

const Title = styled.div`
   font-size: 40px;
   display:flex;
   color: #385963;
   font-weight: 600;
   margin-bottom: 20px;

     @media (max-width: 768px) {
    font-size: 25px;
    margin-top: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    margin-top: 20px;
  }
`;

const Description = styled.div`
   font-size: 20px;
   margin-bottom: 50px;
   color:#91abb3;
   
  @media (max-width: 768px) {
    font-size: 14px;
    margin: 0px 20px 40px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    margin: 0px 10px 30px;
  }
`;

const Image = styled.img`
   height: 500px;
   width: 350px;
   border-radius: 15px;

    @media (max-width: 768px) {
      height: 200px;
      width: 150px;
   }

  @media (max-width: 480px) {
       height: 200px;
      width: 150px;
  }
`;

const AndroidApp = styled.div`
     border:  solid 2px  #385963;
     border-radius: 10px;
     width: 200px;
     padding: 5px;
     display:flex;
     background-color: white;
     align-items:center;
    
     svg{
        height:50px;
        width:50px;
     }
      @media (max-width: 600px) {
       height: auto;
       width: ${({ selectedLanguage }) => (selectedLanguage === 'gr' ? '180px' : '170px')};
       padding:5px;
        svg{
        height:40px;
        width:40px;
     }
     }
`;

const SecondColumn = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 50px;
    align-items: left;

      @media (max-width: 768px) {
      flex-direction:column;
      align-items:center;
      text-align:center;
      justify-content:center;
      margin-left:0;
    }

  @media (max-width: 480px) {
      flex-direction:column;
      align-items:center;
      text-align:center;
      justify-content:center;
        margin-left:0;
  }
`;

const MobileAppHome = () => {

    useEffect(()=>{
        Aos.init({duration:1000})
      },[]);  

   const { i18n } = useTranslation();
   const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';   

  
    return (
      <Container>
        <Image src={MobileAppPhoto} data-aos="fade-right"/>
        <SecondColumn data-aos="zoom-in-down">
         <Title data-aos="zoom-in-down">{i18n.t('downloadMobileApp')}</Title>
         <Description>{i18n.t('downloadTextDescr')}</Description>
         {/* <AndroidApp selectedLanguage={selectedLanguage}> //TODO 
            <GooglePlaySVG/>
            <TextContainer> 
                <DownLoadText> {i18n.t('downloadOn')}</DownLoadText>
                <GooglePlay>{i18n.t('googlePlay')}</GooglePlay>
            </TextContainer>
        </AndroidApp> */}
        </SecondColumn>
      </Container>
    )
}

export default MobileAppHome
